<template>
  <layout-basic>
    <section class="result-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="10" md="7" lg="6">
            <v-card class="result-card" flat>
              <div class="result-body">
                <h1 class="font-sora result-title">Your payment was not completed</h1>
                <p class="result-text">
                  Your signed agreement is safe and nothing has been charged.
                </p>

                <div v-if="paymentsPending" class="info-panel">
                  Online payment is being enabled. Your signed agreement is saved
                  and our team will contact you to complete payment.
                </div>

                <template v-else-if="uuid">
                  <v-btn
                    :loading="loadingCheckout"
                    class="result-primary-btn"
                    depressed
                    block
                    @click="returnToPayment"
                  >
                    Return to payment
                  </v-btn>
                </template>

                <p class="result-secondary">
                  <a href="#" @click.prevent="startAgain">Start again</a>
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PurchaseAPI from '@/Api/purchase.js';

const STORAGE_KEY = 'improve_purchase_uuid';

export default {
  name: 'GetStartedCancel',
  components: { LayoutBasic },
  data() {
    return {
      uuid: null,
      loadingCheckout: false,
      paymentsPending: false,
    };
  },
  metaInfo() {
    return {
      title: 'Payment not completed',
      meta: [{ name: 'robots', content: 'noindex' }],
    };
  },
  created() {
    this.uuid =
      this.$route.query.purchase || PurchaseAPI.storageGet(STORAGE_KEY) || null;
  },
  methods: {
    returnToPayment() {
      if (!this.uuid || this.loadingCheckout) return;
      this.loadingCheckout = true;
      PurchaseAPI.checkout(this.uuid)
        .then((res) => {
          const url = res && res.data ? res.data.checkout_url : null;
          if (url) {
            window.location.href = url;
          } else {
            this.loadingCheckout = false;
            this.$snotify.error('Could not restart checkout. Please try again.');
          }
        })
        .catch((err) => {
          this.loadingCheckout = false;
          const httpStatus = err && err.response ? err.response.status : null;
          if (httpStatus === 503) {
            this.paymentsPending = true;
          } else if (httpStatus === 410) {
            // Purchase expired while they were away: retrying can never work,
            // so clear the stored reference and take them back to a fresh start.
            PurchaseAPI.storageRemove(STORAGE_KEY);
            this.uuid = null;
            this.$snotify.warning('Your purchase session expired. Please start again.');
            this.$router.push('/get-started');
          } else {
            this.$snotify.error('Something went wrong. Please try again.');
          }
        });
    },
    startAgain() {
      PurchaseAPI.storageRemove(STORAGE_KEY);
      this.$router.push('/get-started');
    },
  },
};
</script>

<style scoped>
.result-section {
  --navy: var(--brand-navy, #002458);
  --teal: var(--brand-teal, #08a0a8);
  --grey: var(--brand-grey, #6b7280);
  --line: #e6ebf1;
  --tint: #eef8f8;
  background: #f7f9fb;
  padding: 72px 0 110px;
  min-height: 60vh;
}

.result-card {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 44px 36px 46px;
  box-shadow: 0 12px 40px rgba(0, 36, 88, 0.06);
}

.result-body {
  text-align: center;
}

.result-title {
  font-size: 26px;
  line-height: 1.25;
  font-weight: 700;
  color: var(--navy);
  margin-bottom: 12px;
}

.result-text {
  font-size: 16px;
  color: #2c3a4b;
  margin: 0 0 22px;
}

.info-panel {
  background: var(--tint);
  border: 1px solid rgba(8, 160, 168, 0.35);
  border-radius: 10px;
  color: var(--navy);
  font-size: 14.5px;
  line-height: 1.5;
  text-align: left;
  padding: 14px 16px;
  margin: 0 0 18px;
}

.result-primary-btn {
  background-color: var(--navy) !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  letter-spacing: 0.01em !important;
  border-radius: 8px !important;
  height: 52px !important;
}

.result-primary-btn:hover {
  background-color: var(--teal) !important;
}

.result-secondary {
  margin: 18px 0 0;
  font-size: 14px;
}

.result-secondary a {
  color: var(--teal);
  font-weight: 700;
  text-decoration: none;
}

@media screen and (max-width: 600px) {
  .result-section {
    padding: 44px 0 80px;
  }

  .result-card {
    padding: 32px 20px 34px;
  }

  .result-title {
    font-size: 22px;
  }
}
</style>
